// Helpers for money inputs.
//
// The DB stores amounts as integer cents (`daily_rate_cents`, `total_cents`,
// `deposit_paid_cents`, etc.). Operators think in whole units (3000 baht,
// not 300000 cents). These helpers bridge the two so a money <input> can
// be bound to whole-unit text while the form-state field stays in cents.
//
// Usage:
//   <input :value="centsToInput(form.rental.daily_rate_cents)"
//          @input="form.rental.daily_rate_cents = inputToCents($event.target.value)">

export function centsToInput(cents) {
  if (cents == null || cents === '') return ''
  const v = Number(cents) / 100
  if (!Number.isFinite(v)) return ''
  // Whole baht/dollar → no trailing ".00". Otherwise 2dp.
  return Number.isInteger(v) ? String(v) : v.toFixed(2)
}

export function inputToCents(value) {
  if (value == null || value === '') return 0
  const n = parseFloat(value)
  if (!Number.isFinite(n)) return 0
  return Math.round(n * 100)
}
